import { type QueryFunction } from "@tanstack/react-query";
import { http } from "src/axios";

type ServerAccount = [name: string, metadata: { status: string }];

interface AvcAccount {
  name: string;
  status: string;
}

export interface LkpAccountsResponse {
  accounts: ServerAccount[];
  marketplaces: [countryCode: string][];
  status: number;
}

export const getAuditAccounts: QueryFunction<AvcAccount[], ["audit-accounts"]> = async ({ signal }) => {
  const response = await http.get<LkpAccountsResponse>("/LKPAccounts", { signal });

  return response.data.accounts.map(account => ({
    name: account[0],
    status: account[1].status,
  }));
};
